<template>
  <b-list-group-item
    :to="{
      name: 'EditDeck',
      params: { id: notification.target_id },
      hash: `#comment-${notification.trigger_id}`,
    }"
  >
    <font-awesome-icon class="mr-1 text-warning" :icon="icon" />
    {{ message }} <span>{{ notification.target_name }}</span>
  </b-list-group-item>
</template>

<script>
export default {
  name: "NotificationsWidgetItem",
  data() {
    return {};
  },
  props: {
    notification: {
      required: true,
      type: Object,
    },
  },
  computed: {
    icon() {
      if (this.notification.trigger_type === "reply") {
        return ["far", "comments"];
      }
      if (this.notification.trigger_type === "comment") {
        return ["far", "comment"];
      }
      return [];
    },
    message() {
      if (this.notification.trigger_type === "reply") {
        if (this.notification.count > 1) {
          return `${this.notification.count} replies on`;
        }
        return "1 reply on";
      }

      if (this.notification.trigger_type === "comment") {
        if (this.notification.count > 1) {
          return `${this.notification.count} comments on`;
        }
        return "1 comment on";
      }

      return "Unknown notification";
    },
  },
  methods: {},
};
</script>
